import { render } from "./layoutStockDefaultPdfConfiguration.vue?vue&type=template&id=a8b7e4ba"
import script from "./layoutStockDefaultPdfConfiguration.vue?vue&type=script&lang=js"
export * from "./layoutStockDefaultPdfConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__